const base62 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

// Encode UUID (in hex format) to Base62
export function encodeToBase62(uuid) {
  const uuidBuffer = Buffer.from(uuid.replace(/-/g, ""), "hex"); // Remove hyphens from UUID and create a buffer

  // Convert UUID buffer to a BigInt (128-bit number)
  let bigInt = BigInt("0x" + uuidBuffer.toString("hex"));

  let result = "";

  // Convert the BigInt to Base62
  while (bigInt > 0) {
    result = base62[Number(bigInt % 62n)] + result;
    bigInt /= 62n;
  }

  // Pad the result to ensure it's at least 8 characters long
  return result.padStart(8, "0");
}

// Decode Base62 string back to UUID
export function decodeFromBase62(base62String) {
  let bigInt = 0n;

  // Decode the Base62 string into a BigInt
  for (let i = 0; i < base62String.length; i++) {
    bigInt = bigInt * 62n + BigInt(base62.indexOf(base62String[i]));
  }

  // Convert BigInt back to a hex string (16 bytes or 128-bit)
  const hex = bigInt.toString(16).padStart(32, "0"); // Ensure it is 32 characters long

  // Convert the hex string into a buffer (16 bytes)
  const buffer = Buffer.from(hex, "hex");

  // Format the buffer back to UUID format (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  const uuid = buffer
    .toString("hex")
    .toUpperCase()
    .replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, "$1-$2-$3-$4-$5"); // Add hyphens to match UUID format

  return uuid.toLowerCase();
}
